<div class="g2g-avatar-container" [className]="styleClass">
    <input class="d-none" #file type="file" accept="image/*" multiple (change)="onSelectFile($event)">
    @if(selectedImage) {
    <img [src]="selectedImage" class="img-avatar" [className]="size" [ngClass]="{'max-radius':!interactive}"
        (click)="triggerClick()" />
    } @else {
    <p-avatar [label]="initials" (click)="triggerClick()" icon="pi pi-user" [size]="size" shape="circle" />
    }
</div>